import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { first, map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserService } from './user.service';
import { SaveTempService } from './save-temp.service';
import { Router } from '@angular/router';
import { AlertService } from './alert.service';
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "./storage.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../app.config";
import * as i4 from "./user.service";
import * as i5 from "./save-temp.service";
import * as i6 from "@angular/router";
import * as i7 from "./alert.service";
import * as i8 from "@ngx-translate/core";
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(storageService, http, config, usersService, saveTempService, router, 
    //private checkprofileService: CheckProfileService,
    alertService, translateService) {
        this.storageService = storageService;
        this.http = http;
        this.config = config;
        this.usersService = usersService;
        this.saveTempService = saveTempService;
        this.router = router;
        this.alertService = alertService;
        this.translateService = translateService;
        this.jwtHelper = new JwtHelperService();
        this.currentUserSubject = new BehaviorSubject(this.storageService.getItem("current_user"));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    Object.defineProperty(AuthenticationService.prototype, "currentUserValue", {
        get: function () {
            return this.currentUserSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.refreshToken = function () {
        var _this = this;
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/refreshtoken", null).pipe(map(function (response) {
            _this.afterLogin(response, false, true, null);
            return response;
        }));
    };
    AuthenticationService.prototype.afterLogin = function (response, remember, onlyJwt, returnUrl) {
        var _this = this;
        if (response && response.status == "OK") {
            if (response && response.result.jwt) {
                var user = this.jwtHelper.decodeToken(response.result.jwt);
                if (user.user) {
                    var u = user.user;
                    u.password = "";
                    this.storageService.storePlain('access_token', response.result.jwt);
                    if (remember)
                        this.storageService.storeLocalPlain('access_token', response.result.jwt);
                    this.storageService.store('current_user', u);
                    this.storageService.storePlain("language", u.lingua);
                    this.translateService.use(u.lingua);
                    this.currentUserSubject.next(u);
                    if (!onlyJwt) {
                        this.usersService.preferences()
                            .pipe(first())
                            .subscribe(function (data) {
                            if (data.status === 'OK' && data.result) {
                                _this.saveTempService.empty();
                                _this.storageService.store("user_preferences", data.result);
                                if (!returnUrl || (u.profilo == "D" && returnUrl.indexOf("/driver-app/") == -1))
                                    _this.router.navigate([u.default_homepage]);
                                else
                                    _this.router.navigate([returnUrl]);
                                //this.checkprofileService.getMessages();
                            }
                            else
                                _this.alertService.error(data.error_message);
                        });
                    }
                }
            }
        }
    };
    //username: string, password: string, remember: number, profilo: string = "", mkt: string = ""
    AuthenticationService.prototype.login = function (params) {
        var _this = this;
        var remember = params.remember;
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/authenticate", params)
            .pipe(map(function (response) {
            _this.afterLogin(response, remember, false, params.returnUrl || null);
            return response;
        }));
    };
    AuthenticationService.prototype.loginRemember = function (token) {
        var _this = this;
        this.storageService.storePlain("access_token", token);
        return this.http.post(this.config.getConfig("apiEndpoint") + "/users/refreshtoken", {})
            .pipe(map(function (response) {
            _this.storageService.clear("access_token");
            _this.afterLogin(response, false, false, null);
            return response;
        }));
    };
    AuthenticationService.prototype.clearClientSession = function () {
        this.currentUserSubject.next(null);
        sessionStorage.clear();
        localStorage.clear();
    };
    AuthenticationService.prototype.logout = function (force) {
        force = force || false;
        var ret;
        if (!force)
            ret = this.http.post(this.config.getConfig("apiEndpoint") + "/users/logout", {});
        else
            ret = null;
        return ret;
    };
    AuthenticationService.prototype.getBackendVersion = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/version");
    };
    AuthenticationService.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.inject(i1.StorageService), i0.inject(i2.HttpClient), i0.inject(i3.AppConfig), i0.inject(i4.UserService), i0.inject(i5.SaveTempService), i0.inject(i6.Router), i0.inject(i7.AlertService), i0.inject(i8.TranslateService)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
